import { Component, OnInit, DestroyRef, HostBinding, inject, input } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ThemeService } from "../../../../core-ui/services/theme.service";
import { CardComponent } from "../card/card.component";

@Component({
  selector: "av-spinner",
  templateUrl: "./spinner.component.html",
  styleUrls: ["./spinner.component.scss"],
  standalone: false,
})
export class SpinnerComponent implements OnInit {
  private parent = inject(CardComponent, { optional: true });
  private themeService = inject(ThemeService);
  private destroyRef = inject(DestroyRef);

  readonly size = input<"lg" | "md" | "xs">(undefined);
  readonly mode = input<"dark" | "light">(undefined);

  isDarkMode = false;

  @HostBinding("class") get class() {
    let mode = this.mode();
    if (!mode) {
      mode = this.parent ? (this.isDarkMode ? "light" : "dark") : "light";
    }
    return `av-spinner-${this.size()} av-spinner-mode-${mode}`;
  }

  ngOnInit() {
    this.themeService.themeChanged$().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((theme) => {
      this.isDarkMode = theme?.darkMode;
    });
  }
}
